// Store apparence : pilote l'attribut data-theme sur <html> selon le choix
// utilisateur (Clair / Sombre / Systeme). Persiste dans localStorage.
// Defaut au premier lancement : "dark" pour harmoniser avec le rendu mobile
// (decision v2.3.0). CDC §11.7 (3 modes disponibles).

import { defineStore } from "pinia";

export type ThemeMode = "light" | "dark" | "system";

const LS_KEY = "mailregent:theme";
const DEFAULT_MODE: ThemeMode = "dark";

interface ThemeState {
  mode: ThemeMode;
}

function readLocal(): ThemeMode {
  if (typeof localStorage === "undefined") return DEFAULT_MODE;
  const raw = localStorage.getItem(LS_KEY);
  if (raw === "light" || raw === "dark" || raw === "system") return raw;
  return DEFAULT_MODE;
}

function applyToDom(mode: ThemeMode): void {
  if (typeof document === "undefined") return;
  document.documentElement.setAttribute("data-theme", mode);
}

export const useThemeStore = defineStore("theme", {
  state: (): ThemeState => ({ mode: DEFAULT_MODE }),

  actions: {
    init(): void {
      this.mode = readLocal();
      applyToDom(this.mode);
    },

    setMode(mode: ThemeMode): void {
      this.mode = mode;
      applyToDom(mode);
      if (typeof localStorage !== "undefined") localStorage.setItem(LS_KEY, mode);
    },
  },
});
